import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';

import { DASHBOARD_PAGE } from '../constants/routes';
import { TOKEN_DATA_KEY } from '../constants/login';

function PublicRoute({ children }) {
  const { token: reduxToken } = useSelector((store) => store.defaultReducer);
  const localStorageToken = localStorage.getItem(TOKEN_DATA_KEY);
  const location = useLocation();

  // Use Redux token as primary source, fallback to localStorage
  const token = reduxToken || localStorageToken;

  if (token) {
    return <Navigate to={DASHBOARD_PAGE} replace state={{ from: location }} />;
  }

  return children;
}

export default PublicRoute;
